var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1969_8534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.18878 7.80817L1.36035 10.6366M5.84762 3.32092L5.06718 4.10137C5.00352 4.16503 4.97169 4.19686 4.93542 4.22215C4.90323 4.2446 4.86851 4.26318 4.83197 4.27751C4.79081 4.29366 4.74667 4.30249 4.65839 4.32014L2.82615 4.68659C2.35 4.78182 2.11193 4.82944 2.00055 4.95496C1.90351 5.06432 1.8592 5.21066 1.87928 5.35548C1.90233 5.5217 2.074 5.69338 2.41736 6.03674L5.96023 9.57961C6.30359 9.92297 6.47527 10.0946 6.64149 10.1177C6.78631 10.1378 6.93265 10.0935 7.04201 9.99643C7.16754 9.88504 7.21515 9.64697 7.31038 9.17082L7.67683 7.33859C7.69448 7.2503 7.70331 7.20616 7.71946 7.165C7.73379 7.12846 7.75237 7.09374 7.77482 7.06155C7.80011 7.02529 7.83194 6.99345 7.89561 6.92979L8.67605 6.14935C8.71675 6.10865 8.7371 6.0883 8.75947 6.07053C8.77935 6.05474 8.80039 6.04049 8.82243 6.0279C8.84724 6.01373 8.87369 6.00239 8.9266 5.97972L10.1738 5.44521C10.5376 5.28928 10.7196 5.21131 10.8022 5.08532C10.8745 4.97514 10.9003 4.84089 10.8741 4.71175C10.8442 4.56408 10.7042 4.42413 10.4243 4.14421L7.85276 1.57264C7.57285 1.29273 7.43289 1.15277 7.28522 1.12284C7.15608 1.09666 7.02183 1.12251 6.91165 1.19478C6.78566 1.27742 6.70769 1.45934 6.55176 1.82319L6.01725 3.07037C5.99458 3.12328 5.98324 3.14973 5.96907 3.17454C5.95648 3.19658 5.94223 3.21762 5.92645 3.2375C5.90868 3.25987 5.88833 3.28022 5.84762 3.32092Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1969_8534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin02);
export default __webpack_public_path__ + "static/media/pin-02.899d511c03c8d5ff1437150c70cf7f31.svg";
export { ForwardRef as ReactComponent };